import React from 'react';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import { Telegram, Vk } from '@s2/icons/dist';
import cx from 'classnames';
import styles from './ExternalLinkIcon.module.scss';

const icons = {
  telegram: Telegram(),
  vk: Vk(),
};

interface Props {
  type: string;
  link: string;
}

function ExternalLinkIcon({ type, link }: Props) {
  const { store } = useChatWidgetContext();
  const { setTouched } = store.getState();

  const open = () => {
    setTouched(true);
    window.open(link, '_blank').focus();
  };

  return (
    <div
      className={cx(styles.link, styles[type])}
      onClick={open}
    >
      <div className={styles.caption}>
        {window.ChatWidget.i18n.t('chat_widget.channels.caption')}
        &nbsp;
        <strong>{window.ChatWidget.i18n.t(`chat_widget.channels.${type}`)}</strong>
      </div>
      <div className={cx(styles.icon, styles[type])}>
        <div className={styles.svg}>{icons[type]}</div>
      </div>
    </div>
  );
}

export default ExternalLinkIcon;
